var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowBigger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow-bigger_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.793 7.875 11 12.073l4.207-4.198L16.5 9.168l-5.5 5.5-5.5-5.5 1.293-1.293Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow-bigger_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 -1 0 22)",
  d: "M0 0h22v22H0z"
})))));
export default SvgArrowBigger;